import { connect, ConnectedProps } from 'react-redux'

import ContentHeaderLabel from 'components/accordion/ContentHeaderLabel'
import { setAccordionUrlNode, setSignUpModalIsOpen } from 'redux/actions'
import { RootState, AppDispatch } from 'redux/store';

const mapStateToProps = (state: RootState) => ({
  isLogged: state.user.isLogged,
  controller: state.layout.controller,
  flavour: state.layout.flavour
})

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  setAccordionUrlNode: (urlNode: string) => dispatch(setAccordionUrlNode(urlNode)),
  setSignUpModalIsOpen: (isOpen: boolean) => dispatch(setSignUpModalIsOpen(isOpen))
})

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type ContentHeaderLabelContainerProps = ConnectedProps<typeof connector>

export default connector(ContentHeaderLabel)
